module.exports = __webpack_public_path__ + "static/media/forca-vendas.1dddbb5b.webp";